export const translations = {
  en: {
    appName: 'Quran Kareem',
    nav: { home: 'Home', read: 'Read', mobile: 'Main navigation' },
    lang: { en: 'EN', ar: 'AR', switch: 'Language' },
    home: {
      heroTitle: 'Read & Listen to the Holy Quran',
      heroSubtitle:
        'Browse all 114 surahs with Arabic text, translation, and recitation.',
      browse: 'Browse',
      allSurahs: 'All Surahs',
      shown: '{{count}} shown',
      searchPlaceholder: 'Search by name, meaning, or number…',
      noResults: 'No surahs match "{{query}}"',
      openSurah: 'Open this surah',
      ayahs: '{{count}} ayahs',
    },
    continue: {
      label: 'Continue reading',
      ayah: 'Ayah',
      page: 'Page',
      resume: 'Resume',
      fromPage1: 'From page 1',
    },
    bookmarks: {
      label: 'Bookmarks',
      add: 'Add bookmark',
      remove: 'Remove bookmark',
    },
    reader: {
      reading: 'Reading',
      verseByVerse: 'Verse by Verse',
      listen: 'Listen',
      translation: 'Translation',
      stop: 'Stop',
      surahInfo: 'Surah info',
      listenPageHint: 'Ayah by ayah · auto page',
      selectAyahHint: 'Tap an ayah number to listen or open the ayah page',
      ayahMenuTitle: 'Ayah options',
      ayahMenuTitleN: 'Options for ayah {{n}}',
      menuListen: 'Listen from here (continue)',
      menuListenOnly: 'Listen to this ayah only',
      menuGoToAyah: 'Open ayah page',
      selectAyahPlay: 'Play from this ayah',
      selectAyahPlayN: 'Play from ayah {{n}}',
      startFromAyah: 'Playing from ayah {{n}}',
      pageNav: 'Mushaf page {{current}} of {{total}}',
      mobileActions: 'Reader actions',
    },
    surah: {
      label: 'Surah',
      jumpTo: 'Jump to surah',
      notFound: 'Surah not found.',
      loading: 'Loading surah...',
      prevSurah: 'Previous Surah',
      nextSurah: 'Next Surah',
    },
    ayah: {
      label: 'Ayah',
      of: 'of',
      notFound: 'Ayah not found.',
      loading: 'Loading ayah...',
      prev: 'Previous Ayah',
      next: 'Next Ayah',
      goTo: 'Go to ayah',
      focus: 'Focus',
      tipKeys: 'Tip: use ← → arrow keys to change ayah',
      fullSurah: 'Full surah',
    },
    mushaf: {
      page: 'Page',
      pageOfSurah: 'Page {{current}} of {{total}} in this surah',
      mushafPage: 'Mushaf p. {{page}}',
      juz: 'Juz {{juz}',
      pageAr: 'Page',
      juzAr: 'Part',
      first: 'First',
      last: 'Last',
      prev: 'Prev',
      next: 'Next',
      prevPage: '← Prev',
      nextPage: 'Next →',
      prevPageLabel: 'Previous page',
      nextPageLabel: 'Next page',
      showTranslation: 'Show translation',
      hideTranslation: 'Hide translation',
      openAyahMode: 'Open in ayah mode',
    },
    content: {
      translation: 'Translation',
      tafsir: 'Tafsir',
      transliteration: 'Transliteration',
      bismillah: 'Bismillah',
      quranImage: 'Holy Quran',
    },
    errors: {
      loadList: 'Could not load surahs. Please refresh the page.',
      loadSurah: 'Something went wrong. Please try again.',
      generic: 'Something went wrong.',
    },
    loading: 'Loading...',
    footer: {
      rights: 'All rights reserved.',
      credit: 'Prepared by Eslam Emam',
    },
  },
  ar: {
    appName: 'القرآن الكريم',
    nav: { home: 'الرئيسية', read: 'قراءة', mobile: 'التنقل الرئيسي' },
    lang: { en: 'EN', ar: 'عربي', switch: 'اللغة' },
    home: {
      heroTitle: 'اقرأ واستمع إلى القرآن الكريم',
      heroSubtitle:
        'تصفح سور القرآن الـ١١٤ بالنص العربي والترجمة والتلاوة.',
      browse: 'تصفح',
      allSurahs: 'كل السور',
      shown: '{{count}} سورة',
      searchPlaceholder: 'ابحث بالاسم أو المعنى أو الرقم…',
      noResults: 'لا توجد سور تطابق «{{query}}»',
      openSurah: 'افتح السورة',
      ayahs: '{{count}} آية',
    },
    continue: {
      label: 'متابعة القراءة',
      ayah: 'آية',
      page: 'صفحة',
      resume: 'متابعة',
      fromPage1: 'من الصفحة ١',
    },
    bookmarks: {
      label: 'المفضلة',
      add: 'إضافة للمفضلة',
      remove: 'إزالة من المفضلة',
    },
    reader: {
      reading: 'قراءة',
      verseByVerse: 'آية بآية',
      listen: 'استماع',
      translation: 'الترجمة',
      stop: 'إيقاف',
      surahInfo: 'معلومات السورة',
      listenPageHint: 'آية بآية · تقليب تلقائي',
      selectAyahHint: 'اضغط رقم الآية للاستماع أو فتح صفحة الآية',
      ayahMenuTitle: 'خيارات الآية',
      ayahMenuTitleN: 'خيارات الآية {{n}}',
      menuListen: 'الاستماع من هنا (متابعة)',
      menuListenOnly: 'هذه الآية فقط',
      menuGoToAyah: 'فتح صفحة الآية',
      selectAyahPlay: 'تشغيل من هذه الآية',
      selectAyahPlayN: 'تشغيل من الآية {{n}}',
      startFromAyah: 'التشغيل من الآية {{n}}',
      pageNav: 'صفحة المصحف {{current}} من {{total}}',
      mobileActions: 'إجراءات القراءة',
    },
    surah: {
      label: 'سورة',
      jumpTo: 'انتقل إلى سورة',
      notFound: 'السورة غير موجودة.',
      loading: 'جاري تحميل السورة...',
      prevSurah: 'السورة السابقة',
      nextSurah: 'السورة التالية',
    },
    ayah: {
      label: 'آية',
      of: 'من',
      notFound: 'الآية غير موجودة.',
      loading: 'جاري تحميل الآية...',
      prev: 'الآية السابقة',
      next: 'الآية التالية',
      goTo: 'انتقل إلى آية',
      focus: 'تركيز',
      tipKeys: 'استخدم أسهم ← → للتنقل بين الآيات',
      fullSurah: 'السورة كاملة',
    },
    mushaf: {
      page: 'صفحة',
      pageOfSurah: 'صفحة {{current}} من {{total}} في السورة',
      mushafPage: 'صفحة المصحف {{page}}',
      juz: 'الجزء {{juz}}',
      pageAr: 'صفحة',
      juzAr: 'الجزء',
      first: 'الأولى',
      last: 'الأخيرة',
      prev: 'السابقة',
      next: 'التالية',
      prevPage: 'السابقة ←',
      nextPage: 'التالية →',
      prevPageLabel: 'الصفحة السابقة',
      nextPageLabel: 'الصفحة التالية',
      showTranslation: 'إظهار الترجمة',
      hideTranslation: 'إخفاء الترجمة',
      openAyahMode: 'فتح وضع الآية',
    },
    content: {
      translation: 'الترجمة',
      tafsir: 'التفسير',
      transliteration: 'النطق',
      bismillah: 'بسم الله',
      quranImage: 'القرآن الكريم',
    },
    errors: {
      loadList: 'تعذر تحميل السور. يرجى تحديث الصفحة.',
      loadSurah: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
      generic: 'حدث خطأ ما.',
    },
    loading: 'جاري التحميل...',
    footer: {
      rights: 'جميع الحقوق محفوظة.',
      credit: 'إعداد إسلام إمام',
    },
  },
};

export function interpolate(str, vars = {}) {
  if (!str) return '';
  return str.replace(/\{\{(\w+)\}\}/g, (_, key) =>
    vars[key] !== undefined ? String(vars[key]) : `{{${key}}}`
  );
}

export function translate(lang, key, vars) {
  const parts = key.split('.');
  let node = translations[lang] ?? translations.en;
  for (const part of parts) {
    node = node?.[part];
  }
  if (typeof node !== 'string') return key;
  return interpolate(node, vars);
}
